module.exports = __webpack_public_path__ + "img/maya-opcion-1.83ca01dc.png";